<template>
    <div class="">
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>
        <div class="sceencataes">
            <div class="flx alc scinner cursor jsb">
                <div class="flx alc">
                    <el-dropdown @command="cc" style="width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.eb_id == ''?'':'color:#007AFF !important'">
                            {{form.eb_id == ''?'学历':eb_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 130px;cursor: pointer;" slot="dropdown">
                            <el-dropdown-item :command="item" style="width: 130px;text-align: center;padding: 0;" v-for="item,index in ar1" @click="selscaeen(0)" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                    <el-dropdown @command="cc1" style="width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.salary_id == ''?'':'color:#007AFF !important'">
                            {{form.salary_id == ''?'薪资' : salary_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 130px;cursor: pointer;" slot="dropdown">
                            <el-dropdown-item :command="item" style="width: 130px;text-align: center;padding: 0;" v-for="item,index in ar2" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                    <el-dropdown @command="cc2" style="min-width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.position_id == ''?'':'color:#007AFF !important'">
                            {{form.position_id == ''?'岗位' : position_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 150px;cursor: pointer;max-height: 160px;overflow-y: auto;" slot="dropdown">
                            <el-dropdown-item :command="item" style="width: 145px;text-align: center;padding: 0;" v-for="item,index in ar3" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                    <el-dropdown @command="cc3" style="width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.exp_id == ''?'':'color:#007AFF !important'">
                            {{form.exp_id == ''?'经验' : exp_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 130px;cursor: pointer;" slot="dropdown">
                            <el-dropdown-item  :command="item" style="width: 130px;text-align: center;padding: 0;" v-for="item,index in ar4" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                    <el-dropdown @command="cc4" style="width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.scale_id == ''?'':'color:#007AFF !important'">
                            {{form.scale_id == ''?'公司规模' : scale_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 130px;cursor: pointer;" slot="dropdown">
                            <el-dropdown-item :command="item" style="width: 130px;text-align: center;padding: 0;" v-for="item,index in ar5" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                    <el-dropdown @command="cc5" style="width: 130px;cursor: pointer;text-align: center;" trigger="click">
                        <span class="el-dropdown-link" :style="form.industry_id == ''?'':'color:#007AFF !important'">
                            {{form.industry_id == ''?'行业' : industry_name}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu style="width: 130px;cursor: pointer;max-height: 160px;overflow-y: auto;" slot="dropdown">
                            <el-dropdown-item :command="item" style="width: 130px;text-align: center;padding: 0;" v-for="item,index in ar6" v-text="item.name"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="clears" @click="clearAll">
                    清空筛选条件
                </div>
            </div>
        </div>
        
        <div class="recocon">
            <div class="taavb flx"> 
                <div class="taItem" :class="form.order_by == 'all'?'active' : ''" @click="form.order_by = 'all',getList(),page = 1">
                    全部
                </div>
                <div class="taItem" :class="form.order_by == 'new'?'active' : ''" @click="form.order_by = 'new',getList(),page = 1">
                    最新
                </div>
            </div>
            <div class="reDetails flx jsb">
                <div class="reItemns">
                    <div class="reItem flx alc jsb" v-for="item,index in list" @click="toDetail(item)">
                        <div class="reLeft">
                            <div class="rlt flx alc">
                                <div class="rname" v-text="item.name"></div>
                                <div class="rsalary" v-if="item.salary_mix > 0 && item.salary_max > 0" v-text="`${item.salary_mix}K ~ ${item.salary_max}K`"></div>
                                <div class="rsalary" v-else>面议</div>
                            </div>
                            <div class="rlv flx alc">
                                <div class="rlabel" v-text="item.exp_name"></div>
                                <div class="rlabel" v-text="item.eb_name"></div>
                            </div>
                            <div class="rlb flx alc">
                                <i class="el-icon-location" style="color: #555C70;"></i>
                                <span v-text="item.city_name"></span>
                                <span> · </span>
                                <span v-text="item.area_name"></span>
                            </div>
                        </div>
                        <div class="remiddle">
                            <div class="comTop flx alc">
                                <img :src="$Localimg('companyzw.png')" alt="">
                                <div v-text="item.shop_name"></div>
                            </div>
                            <div class="rlv flx alc">
                                <div class="rlabel" v-text="`${item.shop_people}`"></div>
                                <div class="rlabel" v-text="item.shop_label"></div>
                            </div>
                        </div>
                        <div class="reRight">
                            投递简历
                        </div>
                    </div>
                </div>
                <div class="advs">
                    <div class="advItem" v-for="item,index in advs" @click="toAvd(item)">
                        <img :src="$img(item.image)" alt="" />
                    </div>
                    <div class="codes flx jsb alc">
                        <div class="codeItem">
                            <div class="codeImg">
                                <img :src="$img(qrcode1)" alt="" />
                            </div>
                            <div class="codename">
                                微信小程序
                            </div>
                        </div>
                        <div class="codeItem">
                            <div class="codeImg">
                                <img :src="$img(qrcode2)" alt="" />
                            </div>
                            <div class="codename">
                                企业微信
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getRecruIndex,
        getRecruList,
        getConfig
    } from "@/api/index.js"
    import areaList from '@/assets/area.json'
    import banner from "@/components/banner.vue"
    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
                fullName:"",
                areaList: areaList,
                errorword: "",
                areaProps: {
                    value: 'value',
                    label: 'label',
                    children: 'children',
                    emitPath: true
                },
                accate: [],
                areaValue: [],
                bannerList: [],
                ar1:[],
                ar2:[],
                ar3:[],
                ar4:[],
                ar5:[],
                ar6:[],
                form:{
                    eb_id:'',
                    salary_id:"",
                    position_id:"",
                    exp_id:"",
                    scale_id:"",
                    industry_id:"",
                    order_by:"all"
                },
                form1:{
                    eb_id:'',
                    salary_id:"",
                    position_id:"",
                    exp_id:"",
                    scale_id:"",
                    industry_id:"",
                    order_by:"all"
                },
                page:1,
                eb_name:'',
                salary_name:"",
                position_name:"",
                exp_name:"",
                scale_name:"",
                industry_name:"",
                list:[],
                advs:[],
                qrcode1:"",
                qrcode2:"",
                areaid:""
            };
        },
        created() {
            this.getbanner()
            getConfig().then((res) => {
                console.log('config',res)
                if(res.code == 1){
                    this.qrcode1 = res.data.xcx_qrcode
                    this.qrcode2 = res.data.kefu_qrcode
                }
            })
        },
        methods: {
            toAvd(e){
                window.location.href = e.url
            },
            handleAreaChange(e) {
                let nameArr = this.getLabelByIds(this.areaList, e)
                this.fullName = nameArr[2]
                this.areaid = this.areaValue[0]+"_"+this.areaValue[1]
                this.page = 1
                this.getList()
            },
            toDetail(e){
                let that = this
                this.$router.push({
                    path: '/RecruitmentDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            getLabelByIds(areaData, idArray) {
              const names = []
              let currentList = areaData
              for (const id of idArray) {
                const findItem = currentList.find(item => item.value === id)
                if (!findItem) break
                names.push(findItem.label)
                currentList = findItem.children || []
              }
              return names
            },
            clearAll(){
                let that = this 
                that.form = that.form1
                that.eb_name = '学历'
                that.salary_name = '薪资'
                that.position_name = '岗位'
                that.exp_name = '经验'
                that.scale_name = '公司规模'
                that.industry_name = '行业'
                that.form.eb_id = ''
                that.form.salary_id = ''
                that.form.position_id = ''
                that.form.exp_id = ''
                that.form.scale_id = ''
                that.form.industry_id = ''
                that.form.order_by="all"
                that.page = 1
                that.areaValue = []
                that.fullName = ''
                that.getList()
            },
            cc(e){
                let that = this 
                that.form.eb_id = e.id
                that.eb_name = e.name
                that.page = 1
                that.getList()
            },
            
            cc1(e){
                let that = this 
                that.form.salary_id = e.id
                that.salary_name = e.name
                that.page = 1
                that.getList()
            },
            
            cc2(e){
                let that = this 
                that.form.position_id = e.id
                that.position_name = e.name
                that.page = 1
                that.getList()
            },
            
            cc3(e){
                let that = this 
                that.form.exp_id = e.id
                that.exp_name = e.name
                that.page = 1
                that.getList()
            },
            
            cc4(e){
                let that = this 
                that.form.scale_id = e.id
                that.scale_name = e.name
                that.page = 1
                that.getList()
            },
            
            cc5(e){
                let that = this 
                that.form.industry_id = e.id
                that.industry_name = e.name
                that.page = 1
                that.getList()
            },
            selscaeen(e){
                console.log(e)
            },
            getList(){
                let that = this
                let data = that.form
                data.province_id = that.areaValue[0]
                data.city_id = that.areaValue[1]
                data.area_id = that.areaValue[2]
                data.page = that.page
                that.list = []
                getRecruList(data).then((res) => {
                    console.log('list',res)
                    if(res.code == 1){
                        that.list = res.data.data
                        that.advs = res.data.adv
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            getbanner() {
                let that = this
                getRecruIndex().then((res) => {
                    if (res.code == 1) {
                        that.bannerList = res.data.banner
                        that.ar1 = res.data.where_category[0].list
                        that.ar2 = res.data.where_category[1].list
                        that.ar3 = res.data.where_category[2].list
                        that.ar4 = res.data.where_category[3].list
                        that.ar5 = res.data.where_category[4].list
                        that.ar6 = res.data.where_category[5].list
                        that.getList()
                    }
                })
            }
        }
    };
</script>

<style scoped>
    .remiddle{
        width:500px
    }
    .el-dropdown{
        font-size: 16px !important;
    }
    .el-dropdown-link{
        /* position: relative; */
    }
    .codename{
        font-size: 12px;
        color: #666666;
        text-align: center;
    }
    .codeImg{
        width: 84px;
        height: 84px;
    }
    .codeImg img{
        width: 100%;
        height: 100%;
    }
    .codeItem{
        background: #fff;
        box-sizing: border-box;
        padding: 16px;
    }
    .advItem{
        width: 100%;
        height: 138px;
        margin-bottom: 20px;
        cursor: pointer;
        /* object-fit: cover; */
        
    }
    .advItem img{
        width: 100%;
        /* height: 100%; */
        border-radius: 8px;
    }
    .advs{
        width: 244px;
        box-sizing: border-box;
        padding-top: 17px;
    }
    .reRight{
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }
    .comTop img{
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }
    .comTop div{
        font-size: 16px;
        color: #222222;
    }
    .rlb{
        font-size: 14px;
        color: #555C70;
    }
    .rlabel{
        height: 23px;
        background: #F5F7FA;
        border-radius: 2px;
        font-size: 12px;
        color: #555C70;
        line-height: 23px;
        padding: 0 9px;
        margin: 12px 0;
        margin-right: 10px;
    }
    .rsalary{
        font-weight: 500;
        font-size: 18px;
        color: #007AFF;
    }
    .rname{
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-right: 14px;
    }
    .reLeft{
        width:540px;
        
    }
    .reItem{
        background: #fff;
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 16px;
    }
    .reItemns{
        width: 1194px;
       
    }
    .active{
        background: #007AFF !important;
        color: #fff !important;
    }
    .taavb{
        width: 100%;
        height: 42px;
        background: #ffffff;
        border-bottom: 4px solid #007AFF;
    }
    .taItem{
        width: 145px;
        height: 42px;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
    }
    .clears{
        font-size: 16px;
        color: #999999;
    }
    .sceencataes {
        width: 100%;
        background: #fff;
        height: 48px;
        display: flex;
        align-items: center;
    }

    .scinner {
        width: 1460px;
        margin: 0 auto;
    }
    .recocon{
        width: 1460px;
        margin: 40px auto 0;
    }
</style>